let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cPA85")).then(() => parcelRequire('fguF3'));